import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import useModal from 'hooks/useModal'
import {stopPropagation} from 'utils/dom.utils'
import Icon from 'components/Icon'
import Scrollbar from 'components/Scrollbar'
import get from 'lodash/get'

const EncryptionNote = ({encryptionKeys}) => {
  const {isOpen, close, open} = useModal(false)

  return (
    <>
      <div
        className="notification is-warning is-size-7 has-cursor-pointer"
        onClick={open}>
        <span className="icon">
          <Icon icon="lock" />
        </span>{' '}
        Messages to this chat are secured with end-to-end{' '}
        <a
          href="https://en.wikipedia.org/wiki/RSA_(cryptosystem)"
          target="_blank"
          onClick={stopPropagation}>
          RSA encryption
        </a>
        . Click on this note to see the encryption keys.
      </div>
      <div className={classNames('modal', {'is-active': isOpen})}>
        <div className="modal-background" onClick={close} />
        <div className="modal-content">
          <div className="box">
            <pre className="mb-1">
              <Scrollbar height={180}>
                <code>{get(encryptionKeys, 'public', '')}</code>
              </Scrollbar>
            </pre>
            <pre>
              <Scrollbar height={180}>
                <code>{get(encryptionKeys, 'private', '')}</code>
              </Scrollbar>
            </pre>
          </div>
        </div>
        <button
          className="modal-close is-large"
          aria-label="close"
          onClick={close}
        />
      </div>
    </>
  )
}

EncryptionNote.propTypes = {
  encryptionKeys: PropTypes.shape({
    public: PropTypes.string,
    private: PropTypes.string,
  }),
}

export default EncryptionNote
